import { useSelector } from 'react-redux'

export default function useOrgId(): number {
  return useSelector((state: any) => state.org.id)
}
